import {generateAsyncActionCreators} from '../core/reduxUtils';
import {PAGINATION_PARAM_NAMES} from '../../common/pagination/paginationConstants';
import {USER_INFO_JWT_TOKEN_COOKIE_NAME} from '../../modules/account/accountConstants';

const getCampaignsActionCreators = generateAsyncActionCreators(
  'GET_CAMPAIGNS',
  (params) => ({
    params: {
      ...params,
      [PAGINATION_PARAM_NAMES.PAGE]: params[PAGINATION_PARAM_NAMES.PAGE] || 1,
    },
  })
);

const getSpecialCampaignsActionCreators = generateAsyncActionCreators(
  'GET_SPECIAL_CAMPAIGNS',
  (params) => ({
    params: {
      [USER_INFO_JWT_TOKEN_COOKIE_NAME]: params,
    },
  })
);

const getCustomerSpecialCampaignsActionCreators = generateAsyncActionCreators(
  'GET_CUSTOMER_SPECIAL_CAMPAIGNS',
  (params) => ({
    params: {
      [USER_INFO_JWT_TOKEN_COOKIE_NAME]: params.jwt,
      sku: params?.sku,
      merchantId: params?.merchantId,
      platform: params?.platform,
    },
  })
);

const getNextCampaignsActionCreators = generateAsyncActionCreators(
  'GET_NEXT_CAMPAIGNS',
  (params) => ({
    params: {
      ...params,
      [PAGINATION_PARAM_NAMES.PAGE]: params[PAGINATION_PARAM_NAMES.PAGE] || 1,
    },
  })
);

const actionCreators = {
  getCampaigns: {
    ...getCampaignsActionCreators,
  },

  getSpecialCampaigns: {
    ...getSpecialCampaignsActionCreators,
  },

  getCustomerSpecialCampaigns: {
    ...getCustomerSpecialCampaignsActionCreators,
  },

  getNextCampaigns: {
    ...getNextCampaignsActionCreators,
  },
};

export {
  actionCreators,
  getCampaignsActionCreators,
  getSpecialCampaignsActionCreators,
  getCustomerSpecialCampaignsActionCreators,
  getNextCampaignsActionCreators,
};
